import React, { useState, useEffect } from 'react'
import { Row, Form, Button, Col } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';

const TeacherOnboarding = () => {

    const navigate = useNavigate();

    const { teacherInfo } = useSelector((state) => state.authTeacher);

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
    }, [navigate, teacherInfo])

    const goToProfile1 = () => {
        //window.open(`${window.location.origin}/teacherprofile/`, '_blank')
        window.open(`${window.location.origin}/teacherpublicprofile/${teacherInfo.user}`, '_blank')
    }

    const goToProfile2 = () => {
        window.open(`${window.location.origin}/TeacherNewSubject/`, '_blank')
    }

    const goToProfile3 = () => {
        window.open(`${window.location.origin}/teachersetuppayment/`, '_blank')
    }
    
  return (
    <div>
      <TeacherNavbar />
        <div className="main-content" id="panel">
            <TeacherHeader /><br /><br /><br /><br />        
            <div className="container-fluid mt--6">
                <div className="row">
                    <div className="col-xl-12 questionTitle">   
                        <h3>  <span className='tittleColor4 ' style={{textTransform: 'capitalize'}}>Welcome {teacherInfo?.firstname} {teacherInfo?.lastname} </span></h3>
                    </div>
                    <div className="welcomeG">
                        <div className="offset-xl-2 col-xl-8 ">   
                            <div className="card timeline23">                
                                <div className="card-body "><br />
                                    <div className="timeline " data-timeline-content="axis" data-timeline-axis-style="dashed">                       
                                        <div className="timeline-block">
                                            <span className="timeline-step badge-white bg-gradient-primary">
                                                <i class="fa fa-user-circle" aria-hidden="true"></i>
                                            </span>
                                            <div className="timeline-content">
                                                <h6 className="text-muted font-weight-bold ">
                                                    <span className='tittleColor questionFont onboardL'>Complete your  profile</span>
                                                </h6>                                        
                                                <h6 className=" mt-3 mb-0">Complete your public profile and  share it with your students</h6>
                                                <div className="mt-3">
                                                    <LinkContainer to='' className='btn btn-default' onClick={goToProfile1}>
                                                    <Button variant="info offset-xl-1 bg-gradient-primary border border-0 rounded-pill"> Complete Profile</Button>
                                                    </LinkContainer>    
                                                </div>
                                            </div>                           
                                        </div>    
                                        <div className="timeline-block timeP">
                                            <span className="timeline-step badge-white bg-gradient-warning ">
                                                <i class="fa fa-book" aria-hidden="true"></i>
                                            </span>
                                            <div className="timeline-content">
                                                <h6 className="text-muted font-weight-bold">                            
                                                    <span className='tittleColor22  questionFont onboardL2'>Create your Subjects</span>
                                                </h6>
                                                <h6 className=" mt-3 mb-0">Create subjects, subscription plans and upload a course</h6>
                                                <div className="mt-3">
                                                    <LinkContainer to='' className='btn btn-default bg-gradient-warning onboardBtn2' onClick={goToProfile2} >
                                                    <Button variant="primary offset-xl-1 border border-0 rounded-pill">&nbsp; Create Subjects &nbsp; </Button>
                                                    </LinkContainer> 
                                                </div>
                                            </div>   
                                        </div> 
                                        <div className="timeline-block timeP">
                                            <span className="timeline-step badge-white bg-gradient-danger">
                                                <i class="fa fa-comments" aria-hidden="true"></i>
                                            </span>
                                            <div className="timeline-content">
                                                <h6 className="text-muted font-weight-bold questionFont onboardL3">
                                                    <span className='tittleColor2222'>Setup payouts account  </span>
                                                </h6>    
                                                <div className="mt-3">
                                                    <LinkContainer to='' className='btn btn-default bg-gradient-danger' onClick={goToProfile3}>
                                                    <Button variant="primary offset-xl-1 border border-0 rounded-pill">&nbsp; Setup  payouts  &nbsp; </Button>
                                                    </LinkContainer> 
                                                </div>                                 
                                                <h6 className=" mt-3 onBoardT1 ">
                                                    Connect your bank account to <br /> get paid for your subscriptions 
                                                </h6>                                                                              
                                            </div>                           
                                        </div>                                                                          
                                    </div>                                    
                                </div>                            
                            </div>                        
                        </div>
                    </div>
                </div>
            </div>    
        </div>
    </div>
  )
}

export default TeacherOnboarding
